import { IChoiceGroup, IFormField } from "cayo.ui";
import formRenderers from "./renderers/form-renderers";

const checkChoiceGroup = (annotation: IFormField, v: any) => {
  const choiceGroup = annotation as IChoiceGroup;
  // key in choiceGroup option should always be a string, but v in a model is not always a string
  const hasError = choiceGroup.options.findIndex((o) => o.key === v.toString()) === -1;
  return { hasError };
};

export type checkableTypes = keyof Pick<typeof formRenderers, "choicegroup">;

type ErrorCheckHandler = (annotation: IFormField, v: any) => { hasError: boolean; error?: string };

export const errorCheckers: Record<checkableTypes, ErrorCheckHandler> = {
  choicegroup: checkChoiceGroup,
};
